import React from 'react';

interface ReportFeatureProps {
  onClick?: () => void;
}

const ReportFeature: React.FC<ReportFeatureProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="hover:opacity-80 transition-opacity flex items-center justify-center"
      style={{
        width: 'clamp(18px, 2.5vh, 31px)',
        height: 'clamp(22px, 3vh, 36px)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
      aria-label="Report question"
      title="Report question"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 31 45"
        fill="none"
        style={{ display: 'block', transform: 'translateY(2px)' }}
      >
        <path
          d="M15.5 2.2L30.4 34.2H0.6L15.5 2.2Z"
          stroke="white"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M15.5 11V24.2"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="15.5" cy="29.1" r="1.75" fill="white" />
      </svg>
    </button>
  );
};

export default ReportFeature;

